module.exports = __webpack_public_path__ + "static/img/xszy2.75aa827.png";


//////////////////
// WEBPACK FOOTER
// ./static/img2/xszy2.png
// module id = tfqi
// module chunks = 3